module.exports = __webpack_public_path__ + "static/media/scenario.83e6fdd6.png";